module.exports = __webpack_public_path__ + "static/media/game_consoles2.c4f2ac23.png";